import SecureLS from 'secure-ls'
import JSEncrypt from 'jsencrypt/bin/jsencrypt'

export var ls = new SecureLS({encodingType: 'AES'})

export var encryptor = new JSEncrypt();
